import getAdvancedFilters from './getAdvancedFilters';







const getDefaultAdvancedFilterValue = (name) => {
  const filters = getAdvancedFilters([]).find((filter) => filter.name === name) || {};
  const { filterFacets } = filters;

  if (filterFacets) {
    const facet = filterFacets.find((fac) => fac.selectedDefault) || filterFacets[0];
    return facet.value;
  }

  return '';
};

export default getDefaultAdvancedFilterValue;